// Scala di gravità progressiva: verde (ok) → giallo (login) → arancio
// (attività) → rosso (churn). I due stati intermedi usano colori distinti
// e, insieme alle icone in OrgChurnStatus, restano leggibili anche per daltonici.
export const CHURN_STATUS_META = {
  ok: { label: "OK", color: "green" },
  login_inactive: { label: "Login inattivo", color: "gold" },
  creation_inactive: { label: "Operatività ferma", color: "orange" },
  churn_risk: { label: "Rischio churn", color: "red" },
  disabled: { label: "Disabilitato", color: "default" },
  not_applicable: { label: "Non applicabile", color: "default" },
  config_missing: { label: "Config mancante", color: "purple" },
};

// Stati considerati "a rischio" nel filtro rapido aggregato: rischio churn
// conclamato più i due segnali di inattività (login / attività operativa).
export const CHURN_AT_RISK_STATUSES = [
  "churn_risk",
  "login_inactive",
  "creation_inactive",
];

export const ELIGIBILITY_REASON_LABELS = {
  eligible: "Eligible",
  org_not_active: "Org non attiva",
  not_production: "Non production",
  missing_org: "Org mancante",
};

export const CONFIG_SOURCE_LABELS = {
  global: "Soglie standard",
  org: "Override su questa org",
  none: "Nessuna configurazione",
};

export const CONFIG_SOURCE_DESCRIPTIONS = {
  global:
    "Usa le soglie churn standard, uguali per tutte le org senza override specifico.",
  org:
    "Usa soglie personalizzate solo per questa org, al posto delle soglie standard.",
  none:
    "Non ci sono soglie valide: il calcolo non può stabilire il rischio churn.",
};

export const GIOTTO_ACTIVITY_LABELS = {
  project_created: "Progetto creato",
  project_updated: "Progetto aggiornato",
  page_updated: "Pagina aggiornata",
};

export const getChurnStatusMeta = (status) =>
  CHURN_STATUS_META[status] || { label: status || "n/d", color: "default" };

// Stati per cui ha senso mostrare le frasi login/attività; gli altri
// (disabilitato, esclusa, config mancante) hanno una spiegazione dedicata.
export const CHURN_EVALUATED_STATUSES = [
  "ok",
  "login_inactive",
  "creation_inactive",
  "churn_risk",
];

const pluralGiorni = (n) => `${n} ${n === 1 ? "giorno" : "giorni"}`;

// Frasi dirette, condivise tra pannello e tooltip (single source).
export const formatChurnLoginPhrase = (indicator) => {
  const days = indicator?.days_since_last_login;
  if (days == null) return "Nessun accesso registrato";
  if (indicator.login_inactive) {
    return `Non effettua l'accesso da ${pluralGiorni(days)}`;
  }
  if (days === 0) return "Ultimo accesso oggi";
  return `Ultimo accesso ${pluralGiorni(days)} fa`;
};

export const formatChurnActivityPhrase = (indicator) => {
  const days = indicator?.days_since_last_activity_creation;
  if (days == null) return "Nessuna attività operativa registrata";
  if (indicator.creation_inactive) {
    return `Nessuna attività operativa da ${pluralGiorni(days)}`;
  }
  if (days === 0) return "Ultima attività operativa oggi";
  return `Ultima attività operativa ${pluralGiorni(days)} fa`;
};

export const formatChurnDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString("it-IT");
};

export const formatChurnDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("it-IT");
};

export const normalizeChurnIndicator = (indicator) => {
  if (!indicator) return null;
  return {
    ...indicator,
    statusMeta: getChurnStatusMeta(indicator.status),
  };
};
